import dayjs from 'dayjs';
import Vue from 'vue';

const yearOnly = value => (value ? dayjs(value).format('YYYY') : '');

Vue.filter('yearOnly', yearOnly);
